import { render, staticRenderFns } from "./RecommendList.vue?vue&type=template&id=7955887a"
import script from "./RecommendList.vue?vue&type=script&lang=js"
export * from "./RecommendList.vue?vue&type=script&lang=js"
import style0 from "./RecommendList.vue?vue&type=style&index=0&id=7955887a&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7955887a')) {
      api.createRecord('7955887a', component.options)
    } else {
      api.reload('7955887a', component.options)
    }
    module.hot.accept("./RecommendList.vue?vue&type=template&id=7955887a", function () {
      api.rerender('7955887a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/keeCourses/RecommendList.vue"
export default component.exports